import styled from 'styled-components';

export const SectionContainer = styled.section`
  padding: 4rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f8f8f8;
  width: 100%;
  
  @media (max-width: 768px) {
    padding: 3rem 1rem;
  }
  
  @media (max-width: 480px) {
    padding: 2rem 1rem;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 400;
  text-align: center;
  max-width: 700px;
  margin: 0 auto 3rem auto;
  color: #333;
  
  @media (max-width: 768px) {
    font-size: 2rem;
    margin: 0 auto 2.5rem auto;
    max-width: 90%;
  }
  
  @media (max-width: 480px) {
    font-size: 1.6rem;
    margin: 0 auto 2rem auto;
    line-height: 1.3;
  }
`;

export const CardsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  width: 100%;
  max-width: 1200px;
  margin-bottom: 2rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1.5rem;
    padding: 0 1rem;
  }
  
  @media (max-width: 480px) {
    gap: 1rem;
    padding: 0 0.5rem;
  }
`;

export const Card = styled.div`
  flex: 1;
  padding: 2rem;
  border-radius: 8px;
  background-color: ${({ active }) => active ? '#fff' : 'transparent'};
  box-shadow: ${({ active }) => active ? '0 10px 30px rgba(0, 0, 0, 0.1)' : 'none'};
  cursor: pointer;
  transition: all 0.3s ease;
  max-width: 350px;
  text-align: center;
  
  &:hover {
    transform: translateY(-5px);
  }
  
  @media (max-width: 768px) {
    max-width: 100%;
    padding: 1.5rem;
    margin: 0 auto;
    width: 100%;
    
    &:hover {
      transform: translateY(-2px);
    }
  }
  
  @media (max-width: 480px) {
    padding: 1.2rem;
  }
`;

export const CardIcon = styled.div`
  margin-bottom: 1.5rem;
  opacity: ${({ active }) => active ? '1' : '0.5'};
  transition: opacity 0.3s ease;
  display: flex;
  justify-content: center;
  
  img {
    width: 40px;
    height: 40px;
  }
  
  @media (max-width: 768px) {
    margin-bottom: 1rem;
    
    img {
      width: 35px;
      height: 35px;
    }
  }
  
  @media (max-width: 480px) {
    img {
      width: 30px;
      height: 30px;
    }
  }
`;

export const CardTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: 400;
  margin-bottom: 1rem;
  color: #333;
  opacity: ${({ active }) => active ? '1' : '0.5'};
  transition: opacity 0.3s ease;
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
    margin-bottom: 0.8rem;
    line-height: 1.4;
  }
  
  @media (max-width: 480px) {
    font-size: 1rem;
    margin-bottom: 0.6rem;
  }
`;

export const CardDescription = styled.p`
  font-size: 1rem;
  font-weight: 300;
  color: #666;
  line-height: 1.5;
  opacity: ${({ active }) => active ? '1' : '0.5'};
  transition: opacity 0.3s ease;
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
    line-height: 1.4;
  }
  
  @media (max-width: 480px) {
    font-size: 0.85rem;
  }
`;

export const ProgressBar = styled.div`
  width: 300px;
  height: 4px;
  background-color: #e0e0e0;
  border-radius: 2px;
  position: relative;
  margin: 2rem 0 3rem 0;
  
  @media (max-width: 768px) {
    width: 250px;
    margin: 1.5rem 0 2.5rem 0;
  }
  
  @media (max-width: 480px) {
    width: 200px;
    margin: 1rem 0 2rem 0;
  }
`;

export const ProgressIndicator = styled.div`
  position: absolute;
  left: ${({ position }) => position * 33.33}%;
  width: 33.33%;
  height: 100%;
  background: linear-gradient(90deg, rgb(20, 124, 251) 0%, rgb(0, 66, 232) 100%);
  border-radius: 2px;
  transition: left 0.3s ease;
`;

export const CTAButton = styled.button`
  padding: 0.8rem 2rem;
  border-radius: 50px;
  background: linear-gradient(90deg, #333333 0%, #000000 100%);
  color: white;
  font-weight: 600;
  font-size: 1rem;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
  
  @media (max-width: 768px) {
    padding: 0.7rem 1.8rem;
    font-size: 0.95rem;
    margin-top: 1rem;
  }
  
  @media (max-width: 480px) {
    padding: 0.6rem 1.5rem;
    font-size: 0.9rem;
    gap: 0.4rem;
    
    &:hover {
      transform: translateY(-1px);
    }
  }
`;

export const ArrowIcon = styled.img`
  width: 20px;
  height: 20px;
  
  @media (max-width: 480px) {
    width: 18px;
    height: 18px;
  }
`;